import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import './Stock.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTimes,
    faSearch,
    faAngleDoubleRight,
    faCar,
    faRoad,
    faCalendarAlt,
    faChevronDown,
    faChevronUp,
    faFilter, // Ícono para el botón de filtros en mobile
} from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import Navbar from '../Navbar/Navbar';

export default function Stock({ vehicleType }) {
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [vistaActiva, setVistaActiva] = useState('todos');
    const [busqueda, setBusqueda] = useState('');
    const [filtrosVisibles, setFiltrosVisibles] = useState(false); // ✅ Estado para mostrar/ocultar todos los filtros

    // Estados para filtros colapsables
    const [filtrosColapsados, setFiltrosColapsados] = useState({
        marca: false,
        modelo: false,
        categoria: false,
        combustible: false,
        transmision: false,
        condicion: false,
        anio: false,
        precio: false
    });

    const [filtros, setFiltros] = useState({
        categoria: 'todas',
        precioMin: '',
        precioMax: '',
        anioMin: '',
        anioMax: '',
        kmMax: '',
        marca: 'todas',
        modelo: 'todos',
        combustible: 'todos',
        transmision: 'todas',
        condicion: 'todas',
        ordenar: 'recientes'
    });

    useEffect(() => {
        cargarProductos();
        cargarCategorias();
        cargarMarcas();
        cargarModelos();
    }, [vehicleType]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php?vehicleType=${vehicleType}&soloActivos=1`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false);
            });
    };

    const cargarMarcas = () => {
        fetch(`${baseURL}/marcasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMarcas(data.marca || []);
            })
            .catch(error => console.error('Error al cargar marcas:', error));
    };

    const cargarModelos = () => {
        fetch(`${baseURL}/modelosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setModelos(data.modelos || []);
            })
            .catch(error => console.error('Error al cargar modelos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || item.imagen5 || '/placeholder-car.png';
    };

    const obtenerNombreMarca = (producto) => {
        if (!producto.idMarca) return 'Sin marca';

        const marca = marcas.find(m => String(m.idMarca) === String(producto.idMarca));
        return marca ? marca.nombre : 'Sin marca';
    };

    const obtenerNombreModelo = (producto) => {
        const modelo = modelos.find(m => String(m.idModelo) === String(producto.idModelo));
        return modelo ? modelo.nombre : 'Sin modelo';
    };

    const obtenerCombustiblesUnicos = () => {
        const combustibles = [];
        productos.forEach(producto => {
            if (producto.combustible && !combustibles.includes(producto.combustible)) {
                combustibles.push(producto.combustible);
            }
        });
        return combustibles.sort();
    };

    const obtenerTransmisionesUnicas = () => {
        const transmisiones = [];
        productos.forEach(producto => {
            if (producto.transmision && !transmisiones.includes(producto.transmision)) {
                transmisiones.push(producto.transmision);
            }
        });
        return transmisiones.sort();
    };

    const limpiarFiltros = () => {
        setFiltros({
            categoria: 'todas',
            precioMin: '',
            precioMax: '',
            anioMin: '',
            anioMax: '',
            kmMax: '',
            marca: 'todas',
            modelo: 'todos',
            combustible: 'todos',
            transmision: 'todas',
            condicion: 'todas',
            ordenar: 'recientes'
        });
        setBusqueda('');
        setVistaActiva('todos');
        setFiltrosVisibles(false); // Cierra los filtros al limpiar
    };

    const handleFiltroChange = (filtro, valor) => {
        setFiltros(prev => ({
            ...prev,
            [filtro]: valor
        }));
    };

    const toggleFiltro = (filtro) => {
        setFiltrosColapsados(prev => ({
            ...prev,
            [filtro]: !prev[filtro]
        }));
    };

    const obtenerMarquilla = (producto) => {
        if (producto.oferta === 'si') return { texto: 'OFERTA', clase: 'oferta' };
        if (producto.masVendido === 'si') return { texto: 'DESTACADOS', clase: 'mas-vendido' };
        if (producto.destacado === 'si') return { texto: 'DESTACADO', clase: 'destacado' };
        if (!producto.kilometros || parseInt(producto.kilometros) === 0) return { texto: 'DISPONIBLE', clase: 'disponible' };
        return { texto: 'DISPONIBLE', clase: 'disponible' };
    };

    const filtrarProductos = () => {
        let resultado = [...productos];

        if (vistaActiva === '0km') {
            resultado = resultado.filter(producto => {
                if (!producto.kilometros || producto.kilometros === '') return true;
                const km = parseInt(producto.kilometros);
                return km === 0 || isNaN(km);
            });
        } else if (vistaActiva === 'usados') {
            resultado = resultado.filter(producto => {
                if (!producto.kilometros || producto.kilometros === '') return false;
                const km = parseInt(producto.kilometros);
                return !isNaN(km) && km > 0;
            });
        }

        if (busqueda.trim()) {
            resultado = resultado.filter(producto => {
                const nombreMarca = obtenerNombreMarca(producto);
                const nombreModelo = obtenerNombreModelo(producto);

                return (producto.titulo && producto.titulo.toLowerCase().includes(busqueda.toLowerCase())) ||
                    nombreMarca.toLowerCase().includes(busqueda.toLowerCase()) ||
                    nombreModelo.toLowerCase().includes(busqueda.toLowerCase());
            });
        }

        if (filtros.categoria !== 'todas') {
            resultado = resultado.filter(producto => String(producto.idCategoria) === String(filtros.categoria));
        }

        if (filtros.marca !== 'todas') {
            resultado = resultado.filter(producto => {
                return String(producto.idMarca) === String(filtros.marca)
            });
        }

        if (filtros.modelo !== 'todos') {
            resultado = resultado.filter(producto => {
                return String(producto.idModelo) === String(filtros.modelo)
            });
        }

        if (filtros.combustible !== 'todos') {
            resultado = resultado.filter(producto => producto.combustible === filtros.combustible);
        }

        if (filtros.transmision !== 'todas') {
            resultado = resultado.filter(producto => producto.transmision === filtros.transmision);
        }

        if (filtros.condicion !== 'todas') {
            if (filtros.condicion === '0km') {
                resultado = resultado.filter(producto => !producto.kilometros || parseInt(producto.kilometros) === 0);
            } else if (filtros.condicion === 'usado') {
                resultado = resultado.filter(producto => producto.kilometros && parseInt(producto.kilometros) > 0);
            }
        }

        if (filtros.precioMin.trim()) {
            const precioMin = parseFloat(filtros.precioMin);
            if (!isNaN(precioMin)) {
                resultado = resultado.filter(producto => parseFloat(producto.precio || 0) >= precioMin);
            }
        }

        if (filtros.precioMax.trim()) {
            const precioMax = parseFloat(filtros.precioMax);
            if (!isNaN(precioMax)) {
                resultado = resultado.filter(producto => parseFloat(producto.precio || 0) <= precioMax);
            }
        }

        if (filtros.anioMin.trim()) {
            const anioMin = parseInt(filtros.anioMin);
            if (!isNaN(anioMin)) {
                resultado = resultado.filter(producto => parseInt(producto.anio || 0) >= anioMin);
            }
        }

        if (filtros.anioMax.trim()) {
            const anioMax = parseInt(filtros.anioMax);
            if (!isNaN(anioMax)) {
                resultado = resultado.filter(producto => parseInt(producto.anio || 0) <= anioMax);
            }
        }

        if (filtros.ordenar === 'precio-asc') {
            resultado.sort((a, b) => parseFloat(a.precio || 0) - parseFloat(b.precio || 0));
        } else if (filtros.ordenar === 'precio-desc') {
            resultado.sort((a, b) => parseFloat(b.precio || 0) - parseFloat(a.precio || 0));
        } else if (filtros.ordenar === 'anio-desc') {
            resultado.sort((a, b) => parseInt(b.anio || 0) - parseInt(a.anio || 0));
        } else if (filtros.ordenar === 'anio-asc') {
            resultado.sort((a, b) => parseInt(a.anio || 0) - parseInt(b.anio || 0));
        } else if (filtros.ordenar === 'km-asc') {
            resultado.sort((a, b) => parseInt(a.kilometros || 0) - parseInt(b.kilometros || 0));
        } else {
            resultado.sort((a, b) => parseInt(b.idProducto || 0) - parseInt(a.idProducto || 0));
        }

        return resultado;
    };

    const productosFiltrados = filtrarProductos();
    const totalProductos = productosFiltrados.length;
    return (
        <><Navbar /><div className="stock-page-lateral">
            <div className="stock-header-lateral">
                <div className="stock-container">
                    <h1>NUESTRO STOCK</h1>
                    <p>Encontrá el vehículo perfecto para vos</p>
                </div>
            </div>

            <div className="stock-container">
                <div className="stock-layout-lateral">
                    {/* ✅ Botón de Filtros para mobile */}
                    <button className="mobile-filtros-btn" onClick={() => setFiltrosVisibles(!filtrosVisibles)}>
                        <FontAwesomeIcon icon={faFilter} />
                        Filtros
                    </button>

                    {/* ✅ Sidebar de filtros con clase condicional */}
                    <aside className={`stock-sidebar ${filtrosVisibles ? 'visible' : ''}`}>
                        <div className="sidebar-header">
                            <h3>Filtros</h3>
                            <button className="limpiar-filtros-lateral" onClick={limpiarFiltros}>
                                <FontAwesomeIcon icon={faTimes} />
                                Limpiar
                            </button>
                            {/* ✅ Botón para cerrar filtros */}
                            <button className="cerrar-filtros-btn" onClick={() => setFiltrosVisibles(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        {/* Barra de búsqueda */}
                        <div className="filtro-busqueda">
                            <div className="search-input-container-lateral">
                                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    value={busqueda}
                                    onChange={(e) => setBusqueda(e.target.value)}
                                    className="search-input-lateral" />
                            </div>
                        </div>

                        {/* Vista 
                        <div className="filtro-grupo-lateral">
                            <h4>Condición</h4>
                            <div className="vista-buttons">
                                <button
                                    className={vistaActiva === 'todos' ? 'active' : ''}
                                    onClick={() => setVistaActiva('todos')}
                                >
                                    Todos
                                </button>
                                <button
                                    className={vistaActiva === '0km' ? 'active' : ''}
                                    onClick={() => setVistaActiva('0km')}
                                >
                                    0km
                                </button>
                                <button
                                    className={vistaActiva === 'usados' ? 'active' : ''}
                                    onClick={() => setVistaActiva('usados')}
                                >
                                    Usados
                                </button>
                            </div>
                        </div>*/}

                        {/* Marca */}
                        <div className="filtro-grupo-lateral">
                            <button
                                className="filtro-header-lateral"
                                onClick={() => toggleFiltro('marca')}
                            >
                                <span>Marca</span>
                                <FontAwesomeIcon
                                    icon={filtrosColapsados.marca ? faChevronDown : faChevronUp} />
                            </button>
                            <div className={`filtro-content-lateral ${filtrosColapsados.marca ? 'collapsed' : ''}`}>
                                <select
                                    value={filtros.marca}
                                    onChange={(e) => handleFiltroChange('marca', e.target.value)}
                                >
                                    <option value="todas">Todas las marcas</option>
                                    {marcas.map(marca => (
                                        <option key={marca.idMarca} value={marca.idMarca}>
                                            {marca.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Filtro de Modelo removido a pedido: el select nunca tenía opciones reales
                            para elegir (siempre mostraba sólo "Todos los modelos"). El estado
                            filtros.modelo y su lógica de filtrado quedan (no rompen nada, sólo
                            no se usan más desde la UI) por si se reactiva más adelante. */}

                        {/* Categoría */}
                        <div className="filtro-grupo-lateral">
                            <button
                                className="filtro-header-lateral"
                                onClick={() => toggleFiltro('categoria')}
                            >
                                <span>Categoría</span>
                                <FontAwesomeIcon
                                    icon={filtrosColapsados.categoria ? faChevronDown : faChevronUp} />
                            </button>
                            <div className={`filtro-content-lateral ${filtrosColapsados.categoria ? 'collapsed' : ''}`}>
                                <select
                                    value={filtros.categoria}
                                    onChange={(e) => handleFiltroChange('categoria', e.target.value)}
                                >
                                    <option value="todas">Todas las categorías</option>
                                    {categorias.map(categoria => (
                                        <option key={categoria.idCategoria} value={categoria.idCategoria}>
                                            {categoria.categoria}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Combustible
                        <div className="filtro-grupo-lateral">
                            <button
                                className="filtro-header-lateral"
                                onClick={() => toggleFiltro('combustible')}
                            >
                                <span>Combustible</span>
                                <FontAwesomeIcon
                                    icon={filtrosColapsados.combustible ? faChevronDown : faChevronUp} />
                            </button>
                            <div className={`filtro-content-lateral ${filtrosColapsados.combustible ? 'collapsed' : ''}`}>
                                <select
                                    value={filtros.combustible}
                                    onChange={(e) => handleFiltroChange('combustible', e.target.value)}
                                >
                                    <option value="todos">Todos los combustibles</option>
                                    {obtenerCombustiblesUnicos().map(combustible => (
                                        <option key={combustible} value={combustible}>{combustible}</option>
                                    ))}
                                </select>
                            </div>
                        </div> */}

                        {/* Transmisión 
                        <div className="filtro-grupo-lateral">
                            <button
                                className="filtro-header-lateral"
                                onClick={() => toggleFiltro('transmision')}
                            >
                                <span>Transmisión</span>
                                <FontAwesomeIcon
                                    icon={filtrosColapsados.transmision ? faChevronDown : faChevronUp} />
                            </button>
                            <div className={`filtro-content-lateral ${filtrosColapsados.transmision ? 'collapsed' : ''}`}>
                                <select
                                    value={filtros.transmision}
                                    onChange={(e) => handleFiltroChange('transmision', e.target.value)}
                                >
                                    <option value="todos">Todas las transmisiones</option>
                                    {obtenerTransmisionesUnicas().map(transmision => (
                                        <option key={transmision} value={transmision}>{transmision}</option>
                                    ))}
                                </select>
                            </div>
                        </div>*/}

                        {/* Año 
                        <div className="filtro-grupo-lateral">
                            <button
                                className="filtro-header-lateral"
                                onClick={() => toggleFiltro('anio')}
                            >
                                <span>Año</span>
                                <FontAwesomeIcon
                                    icon={filtrosColapsados.anio ? faChevronDown : faChevronUp} />
                            </button>
                            <div className={`filtro-content-lateral ${filtrosColapsados.anio ? 'collapsed' : ''}`}>
                                <div className="rango-inputs-lateral">
                                    <input
                                        type="number"
                                        placeholder="Desde"
                                        value={filtros.anioMin}
                                        onChange={(e) => handleFiltroChange('anioMin', e.target.value)} />
                                    <input
                                        type="number"
                                        placeholder="Hasta"
                                        value={filtros.anioMax}
                                        onChange={(e) => handleFiltroChange('anioMax', e.target.value)} />
                                </div>
                            </div>
                        </div>*/}

                        {/* Precio */}
                        <div className="filtro-grupo-lateral">
                            <button
                                className="filtro-header-lateral"
                                onClick={() => toggleFiltro('precio')}
                            >
                                <span>Precio (ARS)</span>
                                <FontAwesomeIcon
                                    icon={filtrosColapsados.precio ? faChevronDown : faChevronUp} />
                            </button>
                            <div className={`filtro-content-lateral ${filtrosColapsados.precio ? 'collapsed' : ''}`}>
                                <div className="rango-inputs-lateral">
                                    <input
                                        type="number"
                                        placeholder="$0.000.000"
                                        value={filtros.precioMin}
                                        onChange={(e) => handleFiltroChange('precioMin', e.target.value)} />
                                    <input
                                        type="number"
                                        placeholder="$68.000.000"
                                        value={filtros.precioMax}
                                        onChange={(e) => handleFiltroChange('precioMax', e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </aside>

                    {/* Contenido principal */}
                    <main className="stock-main">
                        {/* Header de resultados */}
                        <div className="resultados-header">
                            <span className="resultados-contador">
                                Mostrando 1-{Math.min(12, totalProductos)} de {totalProductos} vehículos
                            </span>
                            <div className="ordenar-container">
                                <label>Ordenar por</label>
                                <select
                                    value={filtros.ordenar}
                                    onChange={(e) => handleFiltroChange('ordenar', e.target.value)}
                                >
                                    <option value="recientes">Más nuevos</option>
                                    <option value="precio-asc">Precio: menor a mayor</option>
                                    <option value="precio-desc">Precio: mayor a menor</option>
                                    <option value="anio-desc">Año: más nuevo</option>
                                    <option value="anio-asc">Año: más antiguo</option>
                                    <option value="km-asc">Menos kilómetros</option>
                                </select>
                            </div>
                        </div>

                        {/* Grid de productos */}
                        {loading ? (
                            <ProductosLoading />
                        ) : (
                            <div className="stock-grid-lateral">
                                {productosFiltrados.length === 0 ? (
                                    <div className="no-productos">
                                        <FontAwesomeIcon icon={faCar} className="no-productos-icon" />
                                        <h3>No se encontraron vehículos</h3>
                                        <p>Prueba ajustando los filtros</p>
                                    </div>
                                ) : (
                                    productosFiltrados.map(producto => {
                                        const marquilla = obtenerMarquilla(producto);

                                        return (
                                            <Anchor
                                                key={producto.idProducto}
                                                to={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`}
                                                className="stock-card-lateral"
                                            >
                                                <div className="stock-card-image-lateral">
                                                    <img
                                                        src={obtenerImagen(producto)}
                                                        alt={producto.titulo}
                                                        loading="lazy" />
                                                    <div className="marca-logo">
                                                        <span>{obtenerNombreMarca(producto)}</span>
                                                    </div>
                                                    <div className={`stock-marquilla-lateral ${marquilla.clase}`}>
                                                        {marquilla.texto}
                                                    </div>
                                                </div>

                                                <div className="stock-card-content-lateral">
                                                    <h3 className="stock-card-title-lateral">
                                                        {producto.titulo}
                                                    </h3>

                                                    <div className="stock-card-specs-lateral">
                                                        <span>{producto.kilometros || 0} km</span>
                                                        <span>|</span>
                                                        <span>{producto.anio || 'N/A'}</span>
                                                        <span>|</span>
                                                        <span>{producto.combustible || 'Diesel'}</span>
                                                    </div>

                                                    <div className="stock-card-price-lateral">
                                                        <span className="precio-actual-lateral">
                                                            ${String(producto.precio || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Anchor>
                                        );
                                    })
                                )}
                            </div>
                        )}
                    </main>
                </div>
            </div>
        </div></>
    );
}